var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "laugh",
  "use": "laugh-usage",
  "viewBox": "0 0 15.25 15.25",
  "content": "<symbol viewBox=\"0 0 15.25 15.25\" id=\"laugh\"><defs><style>#laugh .cls-1{fill:#ffd972;}#laugh .cls-2{fill:#252c37;}#laugh .cls-3{fill:#f25268;}</style></defs><title>Asset 1</title><g id=\"laugh_Layer_2\" data-name=\"Layer 2\"><g id=\"laugh_Layer_1-2\" data-name=\"Layer 1\"><circle class=\"cls-1\" cx=\"7.63\" cy=\"7.63\" r=\"7.63\" /><path class=\"cls-2\" d=\"M2.63,8a4.88,4.88,0,0,0,5,4.73,4.88,4.88,0,0,0,5-4.73Z\" /><path class=\"cls-3\" d=\"M7.63,9.19A12.67,12.67,0,0,0,3.12,10,5,5,0,0,0,7.64,12.7,5,5,0,0,0,12.16,10,12.67,12.67,0,0,0,7.63,9.19Z\" /><path class=\"cls-2\" d=\"M12.16,6.47a.34.34,0,0,1-.15,0l-2-1a.34.34,0,0,1,0-.62l2-1a.34.34,0,1,1,.31.61L11,5.16l1.35.65a.34.34,0,0,1-.15.65Z\" /><path class=\"cls-2\" d=\"M3,6.47a.34.34,0,0,1-.14-.66l1.39-.62-1.41-.7a.34.34,0,1,1,.31-.61l2.06,1a.34.34,0,0,1,0,.62l-2.06.92A.34.34,0,0,1,3,6.47Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/icon/laugh.icon
// module id = 39
// module chunks = 168707334958949